import { Quote, Star } from "lucide-react";

const RESULT_IMG_1 =
  "https://static.prod-images.emergentagent.com/jobs/10165ba5-237c-4471-8603-ea6dbde73886/images/97680cc52682446abb55b674d8d8e155d1605e8e43cf343666550dfe847ec736.png";
const RESULT_IMG_2 =
  "https://images.unsplash.com/photo-1750698544727-ffc439ade2ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxtaWRkbGUlMjBhZ2VkJTIwbWFuJTIwZ3ltJTIwdHJhaW5pbmclMjBkYXJrfGVufDB8fHx8MTc3ODE0ODcyNXww&ixlib=rb-4.1.0&q=85";
const RESULT_IMG_3 =
  "https://images.unsplash.com/photo-1696005264519-4117082d2923?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxtaWRkbGUlMjBhZ2VkJTIwbWFuJTIwZ3ltJTIwdHJhaW5pbmclMjBkYXJrfGVufDB8fHx8MTc3ODE0ODcyNXww&ixlib=rb-4.1.0&q=85";

const testimonials = [
  {
    img: RESULT_IMG_1,
    weight: "-14 KG",
    name: "Javier, 42 años",
    role: "Pamplona · 5 meses",
    quote:
      "Llevaba 8 años intentándolo solo. Con Aitor entendí que no era una dieta, era cambiar mi vida. Hoy juego al fútbol con mis hijos sin ahogarme.",
  },
  {
    img: RESULT_IMG_2,
    weight: "-19 KG",
    name: "Iker, 47 años",
    role: "Online · 7 meses",
    quote:
      "Trabajo a turnos y pensaba que no había manera. Aitor me hizo un plan que SÍ encajaba. Resultados sin volverme loco.",
  },
  {
    img: RESULT_IMG_3,
    weight: "-9 KG",
    name: "Mikel, 38 años",
    role: "Pamplona · 3 meses",
    quote:
      "Más fuerza, más energía y por primera vez en años, me siento en forma. Ojalá lo hubiera hecho antes.",
  },
];

export const Resultados = () => {
  return (
    <section
      id="resultados"
      data-testid="section-resultados"
      className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-zinc-900"
    >
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-3xl">
            <p className="text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
              03 — Resultados reales
            </p>
            <h2
              data-testid="resultados-heading"
              className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter"
            >
              Hombres como tú.
              <br />
              <span className="text-[#FF5A1F]">Cambios reales.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            No vendo milagros. Vendo procesos serios con hombres serios. Esto es
            lo que cuentan ellos mismos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-zinc-950 border border-zinc-800 hover:border-[#FF5A1F]/60 transition-colors flex flex-col"
            >
              <div className="relative h-72 overflow-hidden grain">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                <div className="absolute top-4 left-4 bg-[#FF5A1F] text-white font-display font-black text-xl px-3 py-1 tracking-tight">
                  {t.weight}
                </div>
              </div>

              <div className="p-7 flex flex-col flex-1">
                <Quote size={22} className="text-[#FF5A1F]" />
                <p className="mt-4 text-zinc-200 text-base leading-relaxed flex-1">
                  "{t.quote}"
                </p>
                <div className="mt-6 pt-5 border-t border-zinc-800 flex items-center justify-between">
                  <div>
                    <p className="font-bold text-white">{t.name}</p>
                    <p className="text-xs uppercase tracking-wider text-zinc-500 mt-1">
                      {t.role}
                    </p>
                  </div>
                  <div className="flex gap-0.5 text-[#FF5A1F]">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <Star key={j} size={14} fill="currentColor" />
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
